import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import pay from './modules/pay'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    pay
  },
  getters
})

export default store
